import React, { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";

const Footer = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const content = {
    en: {
      logoAlt: "Devora Logo",
      description:
        "Devora specializes in education, marketing, sales, and software development. We craft smart digital solutions to help individuals and businesses grow through interactive learning, effective marketing strategies, and advanced software systems tailored to market needs.",
      quickLinks: ["Home", "About", "Services", "Projects", "Contact"],
      services: [
        "IT Solutions",
        "Education Solutions",
        "Marketing Solutions",
        "Sales Solutions",
       
      ],
      contact: {
        address: " jordan, amman",
        phone: "+962 796996828",
        email: "info@devora.com",
      },
      copyright: "© 2025 Devora. All Rights Reserved.",
      languageLabel: "Language",
    },
    ar: {
      logoAlt: "شعار ديفورا",
      description: "ديفورا شركة متخصصة في التعليم، التسويق، المبيعات، وتطوير البرمجيات. نبتكر حلولًا رقمية ذكية تساعد الأفراد والشركات على النمو، من خلال محتوى تعليمي تفاعلي، استراتيجيات تسويق فعّالة، وأنظمة برمجية متطورة تلبي متطلبات السوق.",
      quickLinks: ["الرئيسية", "من نحن", "خدماتنا", "مشاريعنا", "اتصل بنا"],
      services: [
     "حلول التكنولوجيا",
     "حلول التعليم",
     "حلول التسويق",
     "حلول المبيعات",
     ],
      contact: {
        address: "الأردن - عمان",
        phone: "+962 796996828",
        email: "info@devora.com",
      },
      copyright: "© ٢٠٢٥ ديفورا. جميع الحقوق محفوظة.",
      languageLabel: "اللغة",
    },
  };

  const dir = language === "ar" ? "rtl" : "ltr";
  const textAlign = language === "ar" ? "text-end" : "text-start";
  const data = content[language] || content["en"];

  return (
    <footer
      className="container-fluid p-0 footer text-white"
      dir={dir}
      style={{ backgroundColor: "#222" }}
    >

      <div className="container p-5">

        <div className="row" style={{
          display: "flex",
          flexDirection: language === "ar" ? "row-reverse" : "row",
          justifyContent: "space-between",
        }}>
          {/* Logo & Description */}
          <div className="col-12 col-md-4 mb-4" data-aos="fade-up">
            <img
              alt={data.logoAlt}
              className="img-fluid mb-3 floating-logo"
              src="/assets/images/logo1.png"
              style={{ width: "100px" }}
            />
            <p className={textAlign}>{data.description}</p>
            <div className="d-flex gap-3 mt-5 social-icons justify-content-start">
              <a href="#" className="text-white" aria-label="Facebook">
                <i className="fab fa-facebook-f fa-lg"></i>
              </a>
              <a href="#" className="text-white" aria-label="Twitter">
                <i className="fab fa-twitter fa-lg"></i>
              </a>
              <a href="#" className="text-white" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in fa-lg"></i>
              </a>
              <a href="#" className="text-white" aria-label="Instagram">
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a href="#" className="text-white" aria-label="YouTube">
                <i className="fab fa-youtube fa-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div
            className={`col-6 col-md-2 mb-4 ${textAlign}`}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h5 className="mb-3">{language === "ar" ? "روابط سريعة" : "Quick Links"}</h5>
            <ul className="list-unstyled d-flex flex-column gap-2">
              {data.quickLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="text-light text-decoration-none">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div
            className={`col-6 col-md-2 mb-4 ${textAlign}`}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h5 className="mb-3">{language === "ar" ? "الخدمات" : "Services"}</h5>
            <ul className="list-unstyled d-flex flex-column gap-2">
              {data.services.map((service, i) => (
                <li key={i}>
                  <a href="#" className="text-light text-decoration-none">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div
            className={`col-6 col-md-2 mb-4 ${textAlign}`}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <h5 className="mb-3">{language === "ar" ? "تواصل معنا" : "Contact"}</h5>
            <ul className="list-unstyled d-flex flex-column gap-3 ">
              <li className="d-flex align-items-center gap-2">
                <i className="fas fa-map-marker-alt "></i>
                <span style={{ fontSize: "14px" }}>{data.contact.address}</span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <i className="fas fa-phone "></i>
                <span style={{ fontSize: "14px" }}>{data.contact.phone}</span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <i className="fas fa-envelope"></i>
                <span style={{ fontSize: "14px" }}>{data.contact.email}</span>
              </li>
            </ul>
          </div>
          
        </div>

        <hr className="border-light" />

        <div className="text-center mt-3" data-aos="fade-up">
          <small>{data.copyright}</small>
        </div>
      </div>
      
    </footer>
  );
};

export default Footer;
